import analytics from '~/assets/analytics.png';
import manageApp from '~/assets/manage-app.png';
import setup from '~/assets/setup.png';
import PaiIcon from '~/assets/pai.svg';
import Adlabs from '~/assets/adlabs.svg';
import AppConfig from './AppConfig';
import { SvgIcon } from '@mui/material';

const getRealmName = () => AppConfig.realmName || sessionStorage.getItem('realm_name');

const {
  VITE_APP_SAS_URL,
  VITE_APP_SECURE_AD_SERVER,
  VITE_APP_ANALYTICS_URL,
  VITE_APP_SETUP_URL,
  VITE_APP_PAI_URL,
  VITE_APP_ADLABS_URL,
} = import.meta.env;

const UserApps = {
  title: 'Secure Ad Server',
  apps: [
    {
      id: '1',
      title: 'Manage',
      icon: (
        <img
          src={manageApp}
          width={32}
          height={27}
          alt="Manage App Icon"
        />
      ),
      get url() {
        return `${VITE_APP_SAS_URL}/${VITE_APP_SECURE_AD_SERVER}/${getRealmName()}`;
      },
    },
    {
      id: '2',
      title: 'Reports',
      icon: (
        <img
          src={analytics}
          width={33}
          height={27}
          alt="Analytics App Icon"
        />
      ),
      get url() {
        return `${VITE_APP_SAS_URL}/${VITE_APP_SECURE_AD_SERVER}/${getRealmName()}${
          VITE_APP_ANALYTICS_URL
        }`;
      },
    },
    {
      id: '3',
      title: 'Setup',
      icon: (
        <img
          src={setup}
          width={32}
          height={27}
          alt="Setup App Icon"
        />
      ),
      url: VITE_APP_SETUP_URL,
    },
  ],
  products: [
    {
      id: '4',
      title: 'Player Ad Insertion',
      icon: (
        <SvgIcon
          inheritViewBox
          component={PaiIcon}
          color="inherit"
          sx={{ width: 35, height: 20 }}
        />
      ),
      url: VITE_APP_PAI_URL,
      windowName: 'pai-profile',
    },
    {
      id: '5',
      title: 'AdLabs Studio - Engagement Ads',
      icon: (
        <SvgIcon
          inheritViewBox
          component={Adlabs}
          color="inherit"
          sx={{ width: 35, height: 20 }}
        />
      ),
      url: VITE_APP_ADLABS_URL,
      windowName: 'ad-manage',
    },
  ],
};

export default UserApps;
